import useUserStore from "@store/useUserStore";
import type { IMemberTag } from "@interfaces/tag.interface";
import { CompanyAvatar, CompanyAvatarSizes } from "@ui/Avatars/CompanyAvatar";
import { TagLabel } from "@ui/Content";

type Props = {
  item: IMemberTag;
  showEmail?: boolean;
} & React.HTMLAttributes<HTMLElement>;

export const SuggestionMember = ({ item, showEmail, ...rest }: Props) => {
  const { activeUser } = useUserStore();

  const displayName =
    item.first_name && item.last_name ? `${item.first_name} ${item.last_name}` : item.email;

  return (
    <div {...rest} className="flex min-w-0 cursor-pointer items-center gap-1 p-2">
      <div className="flex items-center gap-2 flex-1 overflow-hidden">
        <CompanyAvatar
          userProps={{
            first_name: item.first_name,
            last_name: item.last_name,
            email: showEmail ? item.email : undefined,
          }}
          size={CompanyAvatarSizes.SMALL}
          logoUrl={item.avatar_url}
          classNames="border rounded-full w-5 h-5"
        />
        <TagLabel>
          {displayName} {item.id === activeUser?.id ? "(Me)" : null}
        </TagLabel>
      </div>
      <TagLabel className="text-gray-450 dark:text-gray-200">{item.title}</TagLabel>
    </div>
  );
};
